<template>
	<div style="margin-bottom: 50px;box-sizing: border-box;">
		<div class="wrap">
		<div class="header">
			<div style="display: flex;align-items: center;">
				<!-- <img src="../../assets/images/indexIcon.png" alt=""> -->
				<!-- <p><span>首页-项目需求池</span>-{{proDetail.title}}</p> -->
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			
			<div style="background:#E5EDFB;">
				<div style="width: 120px; height: 40px;background: #0052D9;
			border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;
			line-height: 40px;text-align: center;">
					课题定位
				</div>
			</div>
			<div class="mktitle">
				<div :class="activeCard==1?'activeCard':''" @click="activeCard = 1">邀请专家定位</div>
				<!-- <div :class="activeCard==2?'activeCard':''" @click="activeCard = 2">通过提问定位</div>
				<div :class="activeCard==3 || activeCard == 4?'activeCard':''" @click="activeCard = 3">邀请专家定位</div> -->
			</div>
			<div class="card-one" v-if="activeCard == 1">
				<div class="miaosu">
					问题描述：
				</div>
				<div class="content">
					<div>
						<!-- <div class="item-content">
							<div class="muban" @click="$router.push(`/kongEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从空白模板创建</p>
								</div>
							</div>
							<div class="muban" v-if='$store.state.releaseInfo[0].id'
								@click="$router.push(`/histroyEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从上次修改创建</p>
								</div>
							</div>
							<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
								@click="toMbDetail(item.id,0)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>{{item.name}}</p>
								</div>
							</div>

						</div> -->
					</div>
					<!-- <div class="miaosu">
						问题描述显示：
					</div> -->
					<div class="content" v-html="renderedMarkdown1"></div>
					<!-- <div style="margin: 15px 0;">
						<el-upload :on-success='uploadWZB1' class="upload-demo"
							:headers='{token:$store.state.userInfo.token}' accept='.pdf,.word,.docx,.txt,.xlsx'
							:action="uploadPath+'common/upload'" multiple :file-list="fileList1" :limit='3'>
							<el-button size="small" type="primary">上传文件</el-button>
						</el-upload>
					</div> -->
					<div class="item-detail">
						<div  v-if="proDetail.files!=''" class="detail-line" v-for="(item,index) in proDetail.files">
							<!-- <a :href="getImgSrc(item)" download="">下载</a> -->
							<span @click="getPath(item)" style="color: #0052D9;">下载</span>
						</div>
					</div>
					<div class="jieshao">
						<div class="miaosu">
							个人介绍：
						</div>
						<div class="content">
							<div class="wenJuan">
								<el-radio-group  v-model="proDetail.people_msg_type"  @change="handlePeopleMsgTypeChange">
									<div v-if="proDetail.people_msg_type==1" style="margin: 25px 0;">
										<el-radio :label="1">使用系统中的个人信息</el-radio>
										</div>
									<div v-if="proDetail.people_msg_type==2" style="margin: 25px 0;">
										<el-radio :label="2">使用学术/单位个人主页</el-radio>
										<input 
											:disabled='proDetail.people_msg_type !== 2' type="text" v-model="proDetail.home_page"
											style="width: 300px;height: 30px;border: 1px solid #D2D2D2;"></div>
									<div  v-if="proDetail.people_msg_type==3" style="margin: 25px 0;display: flex;align-items: center;">
										<el-radio :label="3">上传个人简历</el-radio>
										<div style="margin: 15px 0;">
											<div class="detail-line" v-for="(item,index) in proDetail.file">
												<!-- <a :href="getImgSrc(item)" download="">下载</a> -->
												<span  @click="getPath(item)" style="color: #0052D9;">下载</span>
											</div>
										</div>
									</div>
									<div  v-if="proDetail.people_msg_type==4" style="margin: 25px 0;"><el-radio :label="4">直接介绍自己</el-radio>
									<input	:disabled='proDetail.people_msg_type !== 4' type="text" v-model="proDetail.people_msg" style="width: 300px;height: 30px;border: 1px solid #D2D2D2;">
									</div>
								</el-radio-group>
							</div>
						</div>
					</div>
					<div class="jieshao">
						<div class="miaosu">
							专家要求：
						</div>
						<div class="content">
							<div class="wenJuan">
								<el-radio-group v-model="proDetail.specialist_type" @input='clog'>
									<div v-if="proDetail.specialist_type==1" style="margin: 25px 0;"><el-radio :label="1">高级专家(副高职称/8年以上行业经验)</el-radio></div>
									<div v-if="proDetail.specialist_type==2" style="margin: 25px 0;"><el-radio :label="2">资深专家(高级职称/15年以上行业经验)</el-radio></div>
									<div v-if="proDetail.specialist_type==3" style="margin: 25px 0;display: flex;align-items: center;"><el-radio
											:label="3">权威专家(三级教授及以上包含院士/杰青)</el-radio></div>
					
								</el-radio-group>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</div>
</template>

<script>
	export default {
		data() {
			return {
				centerDialogVisible: false,
				downLoadPath:'',
				proDetail:'',
				activeCard: 1,
				radio: '',
				JSradio: '',
				zyTemplate: [],
				fileList1:[],
				renderedMarkdown1:'',
			}
		},
		watch: {  
		    proDetail: {  
		        handler(n, o) {  
		            console.log('内容的ID', n.content); // 假设 n.content 是你想要的  
					this.renderedMarkdown1 = n.content
		            // this.fetchMarkdownInfo(n.content, 'renderedMarkdown1');  
					
		        },  
		        deep: true,  
		        immediate: true  
		    }  
		},
		
		created() {
			this.getDetail(this.$route.query.id);
		},
		methods: {
			handlePeopleMsgTypeChange() {},
			async getDetail(id) {
				const detail = await this.$api.ktdwzjGetDetail({
					id: id
				})
				this.proDetail = detail.data
				console.log('课题定位详情',detail.data);
			},
			getPath(item) {  
			  console.log('getPath called with item:', item);  // 添加这行来调试  
			  this.downLoadPath = item;  
			  this.centerDialogVisible = true;  
			  this.downloadFile(this.downLoadPath)
			},
			async fetchMarkdownInfo(id, targetProperty) {
			      try {  
			        const release = await this.$api.markdownGetInfo({ id:id});  
			        
			        this[targetProperty] = release.data.content;  
			      } catch (error) {  
			        // console.error('获取 Markdown 信息失败', error);  
			      }  
			},  
			
			clog(e) {
				console.log(e);
			},
			downloadFile(path) {
				const url = this.getImgSrc(path) + '?response-content-type=application/octet-stream'
				console.log(url)
				let a = document.createElement("a");
				a.setAttribute("href", url);
				a.setAttribute("download", this.proDetail.title);
				a.setAttribute("target", "_blank");
			
				a.click()
			},
		}
	}
</script>
<style>
	.el-radio__inner {
		border-radius: 0;
	}

	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		/* 这里显示矩形的一半边框再旋转45度来实现对勾样式 */
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	}
</style>
<style scoped lang="less">
	.wenJuan {
		margin-left: 80px;
	}

	.item-content {
		display: flex;

		.muban {
			
			display: flex;
			justify-content: center;
			align-items: center;
			width: 148px;
			height: 148px;
			background: #F6F6F6;
			cursor: pointer;
			margin-left: 50px;
			&>div {
				display: flex;
				justify-content: center;
				flex-wrap: wrap;
			}

			p {
				width: 100%;
				text-align: center;
				margin-top: 10px;
			}
			&:first-child {
				margin-left: 0;
			}
		}

		.muban:hover {
			background: #e3e3e3;
		}
	}

	/deep/.el-radio {
		color: black;
		width: 200px;
	}

	.submit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		text-align: center;
		margin: auto;
		margin-top: 40px;
		line-height: 40px;
		color: white;
		cursor: pointer;
		font-size: 18px;
	}

	.body {
		.card-four {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;
			flex-wrap: wrap;

			.AIdingwei {
				margin-top: 20px;

				.AIbody {
					margin: 15px 0;
					margin-left: 50px;

					.Aianswer {
						margin: 20px 0;
						width: 1000px;
						height: 130px;
						background: #F6F6F6;
						border: 1px solid #E5E5E5;
						padding: 35px;
						box-sizing: border-box;

						p {
							height: 60px;
							font-family: PingFang;
							font-weight: 500;
							color: #888888;
							line-height: 30px;
							overflow: hidden;
							position: relative;

							&::after {
								position: absolute;
								bottom: 0;
								right: 10px;
								width: 1.2em;
							}
						}


					}
				}
			}
		}

		.card-three {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;
			flex-wrap: wrap;

			.jieshao {
				margin-top: 20px;
			}

			.head-muban {
				width: 100%;

				.content {
					padding-top: 20px;
					padding-left: 70px;
					margin-bottom: 40px;
				}
			}

		}

		.card-two {
			width: 880px;
			margin-top: 30px;
			margin-left: 60px;
		}

		.card-one {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;

			.content {
				padding-top: 30px;
				flex: 1;
				flex-wrap: wrap;
			}
		}

		.mktitle {
			.activeCard {
				background: #0052D9;
				color: white;
			}

			margin-top: 30px;
			margin-left: 35px;
			display: flex;
			width: 900px;

			&>div {
				cursor: pointer;
				line-height: 46px;
				text-align: center;
				margin-left: 25px;
				width: 262px;
				height: 46px;
				background: #F6F6F6;
				border: 1px solid #E5E5E5;
			}
		}

		padding: 20px 0;
		padding-top: 30px;
		background: white;
		padding-bottom: 50px;
	}
</style>